import { useOrganization } from 'hooks';
import { useCallback } from 'react';
import { LuxonZone } from 'types/LuxonZone';
import { getPayPeriodTimeRange } from 'utils/payPeriodUtils';

export default function usePayPeriodTimeRangeGet(zone: LuxonZone) {
  const organization = useOrganization();

  return useCallback(
    (time: number) => {
      return getPayPeriodTimeRange(organization.organizationPayPeriod!, time, zone);
    },
    [organization.organizationPayPeriod, zone]
  );
}
